import React from "react";
import "./ChooseSupport.css";
import logo from "../../assets/logo.png";

export default function ChooseSupport() {
  return (
    <div className="choose-support fade-in">

      {/*  */}
      <h1 className="support-title fade-in">دعم التطبيق</h1>

      {/*  */}
      <div className="support-logo-box fade-in">
        <img src={logo} className="support-logo" alt="logo" />
      </div>

      {/*  */}
      <p className="support-text fade-in">
        اختر نوع الدعم الذي ترغب في تقديمه:
      </p>

      {/*  */}
      <div className="support-btns fade-in">
        <button className="support-btn">دعم مادي</button>
        <button className="support-btn">دعم عيني</button>
      </div>

    </div>
  );
}
